module.exports = __webpack_public_path__ + "img/Onearea@2x.880cac13.png";